<template>
  <v-card flat class="my-card" id="audio-inspections-details-card" min-height="560">
    <v-row>
      <v-col cols="10">
        <div class="inspection-details-title">
          {{inspectionDetails.title}}
        </div>
        <div class="inspection-details-date d-flex">
          <span class="inspections-calendar-icon">
            <v-img
              contain
              height="24"
              width="24"
              :src="`${publicPath}img/icons/`+inspectionDetails.icon+'.svg'"
            ></v-img>
          </span>
          <span>{{getDetailsDate(inspectionDetails.date)}} </span>
          <span class="pl-1">({{inspectionDetails.date}})</span>
        </div>
      </v-col>
      <v-col
        v-if="showSmallEditBtn"
        cols="2"
        class="d-flex justify-end align-center"
      >
        <v-btn fab small depressed color="#EAAC30"
          @click="$emit('edit-action')">
          <v-icon size="16">{{edit_icon}}</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12">
        <div class="d-inline-flex audio-file-container" @click="downloadAudioInspection">
          <div class="mr-2"><v-icon size="16">{{music_icon}}</v-icon></div>
          <div>{{ inspectionDetails.file_name }}</div>
        </div>
      </v-col>
      <v-col cols="12" class="mt-3">
        <v-textarea
          :value="inspectionDetails.notes"
          label="Your Comments"
          readonly
          filled
          auto-grow
          hide-details
          no-resize
          rows="5"
          :prepend-inner-icon="file_icon"
          color="#262338"
          background-color="#EFF0F7"
          class="my-textarea"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-row class="edit-inspection-btn-container">
      <v-col cols="12" sm="12" md="8" lg="6" xl="5">
        <v-btn block outlined class="my-btn edit-inspection-btn"
          @click="$emit('edit-inspection')">
          {{$t('editInspection')}}
          <v-spacer></v-spacer>
          <v-icon size=16>{{edit_icon}}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import {mapGetters} from 'vuex';
  import moment from "moment";
  import axios from 'axios';

  export default {
    name: 'AudioInspectionDetailsCard',
    props: {
      showSmallEditBtn: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters(["inspectionDetails"]),
      lang: {
        get() {
          return this.$i18n.locale;
        }
      }
    },
    data: () => ({
      publicPath: process.env.BASE_URL,
      file_icon: "$vuetify.icons.file_icon",
      edit_icon: "$vuetify.icons.edit_icon",
      music_icon: "$vuetify.icons.music_icon",
    }),
    methods: {
      getDetailsDate(date) {
        return moment(date).locale(this.lang).format("ddd D MMMM YYYY");
      },
      downloadAudioInspection() {
        this.showLoader = true;
        let fileName = this.inspectionDetails.file_name;
        
        axios({
          url: `${process.env.VUE_APP_BASE_URL}/api/recordings/${this.inspectionDetails.uuid}/download`,
          method: 'GET',
          responseType: 'blob',
        }).then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          this.showLoader = false;
        });
      },
    }
  };
</script>

<style type="text/css">
  .inspection-details-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 1px;
    color: #4E4B66;
  }

  .inspection-details-date {
    font-weight: 600;
    font-size: 13px;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: #6E7191;
  }
  
  #audio-inspections-details-card .v-textarea.v-text-field--enclosed textarea {
    margin-top: 18px;
    font-weight: 500;
    font-size: 13px;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: #14142B;
  }

  #audio-inspections-details-card .my-textarea label.v-label {
    top: 0px;
    font-weight: 600;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: #6E7191 !important;
  }

  #audio-inspections-details-card .my-textarea label.v-label--active {
    transform: translateY(0px) scale(0.85);
  }

  #audio-inspections-details-card .my-textarea.v-text-field--enclosed .v-input__prepend-inner {
    margin-top: 0;
  }

  #audio-inspections-details-card .hives-title {
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.75px;
    padding-left: 10px;
  }

  #audio-inspections-details-card .hive-chip {
    width: 60px;
    height: 28px;
    padding: 3px 10px;
    font-size: 13px;
    line-height: 22px;
    font-weight: 500;
    letter-spacing: 0.25px;
    justify-content: center;
    border-radius: 8px;
  }

  #audio-inspections-details-card .edit-inspection-btn-container {
    margin-top: 40px;
    justify-content: flex-end;
  }

  #audio-inspections-details-card button.my-btn.edit-inspection-btn {
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.75px;
    background-color: #EAAC30;
    border: 2px solid #EAAC30;
    padding: 9px 22px;
    height: 50px;
  }

  #audio-inspections-details-card button.my-btn.edit-inspection-btn:hover {
    background-color: #ffffff;
    color: #262338;
  }

  #audio-inspections-details-card button.edit-inspection-btn:hover::before {
    opacity: 0;
  }

  .hive-numbers-container {
    height: 100px;
    overflow-y: auto;
  }

  .inspections-calendar-icon {
    margin: auto 10px auto 0;
  }

  .audio-file-container:hover {
    cursor: pointer;
    color: #14142B;
    text-decoration: underline;
  }

  .audio-file-container {
    color: #4E4B66;
  }

  @media screen and (max-width: 960px) {
    #audio-inspections-details-card.my-card {
      border-radius: 0;
    }
  }
</style>